module.exports = __webpack_public_path__ + "static/media/YFII-BNB.f104bfa1.svg";